/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React from "react";
import Row from "./Row";
import {
  Typography,
  TextField,
  Backdrop,
  CircularProgress,
} from "@material-ui/core";
import Actions from "./../../../../../../fluid/Actions/ActionFactory";
import ErrorMessageAlert from "../../../../../Utilities/ErrorMessageAlert";
import { withStyles } from "@material-ui/core/styles";
const useStyles = (theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
});

function getMockCell({
  rowIndex = 0,
  colIndex = 0,
  value = "",
  backgroundColor = "#ffffff",
  fontColor = "#000000",
  border = "1px solid #D4D4D4",
  borderTop = "",
  borderRight = "1px ",
  borderBottom = "",
  borderLeft = "",
  width,
  height,
  colSpan = 1,
  rowSpan = 1,
}) {
  return {
    col_index: colIndex,
    row_index: rowIndex,
    style: {
      width: width,
      height: height,
      background_color: backgroundColor,
      font_color: fontColor,
      border_bottom: borderBottom || "NONE",
      border_left: borderLeft || "NONE",
      border_top: borderTop || "NONE",
      border_right: borderRight || "NONE",
      border: border,
      bold: false,
      align: "center",
      wrap: false,
      italic: false,
    },
    value: value,
    col_span: colSpan,
    row_span: rowSpan,
  };
}
//ascii vlaue of A
const asciiValueOfA = "A".charCodeAt(0);
const asciiValueOfZ = "Z".charCodeAt(0);
const aplphbetLength = 26;

//colindx ascii number from string
//treat 'A' as 1
function colIndxStringToColNo(colIndxString) {
  //remove spaces
  colIndxString = colIndxString.trim();
  let multiplier = 1; // 26 power 0 iniialzed

  let colNumber = 0;
  //start from last character in passed colINdx string
  for (let char of colIndxString.split("").reverse()) {
    //check if its valid character
    let charAsciiValue = char.charCodeAt(0);
    if (charAsciiValue < asciiValueOfA || charAsciiValue > asciiValueOfZ) {
      throw new Error("invalid col_indx passed ");
    }

    colNumber = colNumber + multiplier * (charAsciiValue - asciiValueOfA + 1);
    multiplier = multiplier * aplphbetLength;
  }
  return colNumber;
}
//treat 1 as 'A'
function colNoToColIndxString(colNo) {
  if (colNo === 0) return "0";
  let colIndxString = "";
  while (colNo > aplphbetLength) {
    colIndxString =
      String.fromCharCode((colNo % aplphbetLength) + asciiValueOfA - 1) +
      colIndxString;

    colNo = Math.floor(colNo / aplphbetLength);
  }
  return String.fromCharCode(colNo + asciiValueOfA - 1) + colIndxString;
}
//add row indexing
function addRowSequenceNos(rowsData, headerRow) {
  if (!rowsData) return;
  console.log("Table :::: Rows Data : ", rowsData)
  console.log("Table :::: HEader Row : ", headerRow)
  if (rowsData[1][0].row_index <= headerRow) {
    rowsData.shift()
  }
  let sequenceAddedRowsData;
  //this variable assist in adding row index for records without row_index or empty row records
  let lastProvidedRowIndex = 1;
  sequenceAddedRowsData = rowsData.map(function (singleRowData) {
    //read row index from first cell and assume it's same for entire row
    let sequenceNo;
    if (singleRowData[0]) {
      sequenceNo = singleRowData[0].row_index;
      //store last provieded row_index
      lastProvidedRowIndex = sequenceNo;
    } else {
      sequenceNo = lastProvidedRowIndex + 1;
    }
    return [
      getMockCell({
        rowIndex: sequenceNo,
        colIndex: 0,
        value: sequenceNo,
        backgroundColor: "#EDEBE9",
        fontColor: "#696968",
        border: "1px solid #D4D4D4",
      }),
      ...singleRowData,
    ];
  });
  return sequenceAddedRowsData;
}
//add column indexing
function getColumnIndexArray(totalCols, row_index = 0) {
  let colIndexArray = [];
  //inital guy is (0,0)
  colIndexArray[0] = getMockCell({
    rowIndex: row_index,
    colIndex: 0,
    value: "",
    backgroundColor: "#EDEBE9",
    fontColor: "#696968",
  });
  for (let colNo = 1; colNo < totalCols; colNo++) {
    colIndexArray[colNo] = getMockCell({
      rowIndex: row_index,
      colIndex: colNoToColIndxString(colNo),
      value: colNoToColIndxString(colNo),
      backgroundColor: "#EDEBE9",
      fontColor: "#696968",
      border: "1px solid #D4D4D4",
    });
  }
  return colIndexArray;
}
//get column index array for vertical table
function getColumnIndexArrayForVerticalTable(headerCol, startCol, endCol) {
  console.log("col ind arr vert table", headerCol, startCol, endCol);
  let colIndArr = [];
  //push "0" and header col to start
  colIndArr.push(
    getMockCell({
      rowIndex: 0,
      colIndex: 0,
      value: "",
      backgroundColor: "#EDEBE9",
      fontColor: "#696968",
    })
  );
  colIndArr.push(
    getMockCell({
      rowIndex: 0,
      colIndex: headerCol,
      value: headerCol,
      backgroundColor: "#EDEBE9",
      fontColor: "#696968",
    })
  );
  // let strtColAsNo = colIndxStringToColNo(startCol);
  // let endColAsNo = colIndxStringToColNo(endCol);
  for (let colNo = startCol; colNo <= endCol; colNo++) {
    colIndArr[colNo] = getMockCell({
      rowIndex: 0,
      colIndex: colNoToColIndxString(colNo),
      value: colNoToColIndxString(colNo),
      backgroundColor: "#EDEBE9",
      fontColor: "#696968",
      border: "1px solid #D4D4D4",
    });
  }
  return colIndArr;
}

function updateColIndex(dataRow) {
  dataRow.forEach((cell, index) => {
    if (cell.col_index === null) {
      cell.col_index = colNoToColIndxString(index);
    }
  });
}

class Sheet extends React.Component {
  constructor(props) {
    super(props);

    this.scrollRef = React.createRef();

    this.state = {
      //row metrics for horizontal table
      hrzntlTblFiles: [],
      startingRow: 0,
      endingRow: 0,
      minRowNo: Number.NEGATIVE_INFINITY,
      maxRowNo: Number.POSITIVE_INFINITY,
      rows: [],
      columnIndexesRow: [],
      columnNamesRow: [],
      MAX_NUM_ROWS_TO_FETCH_LAZILY_ON_SCROLL: 50,
      scrollPrevY: 0,

      //col metrics for vertical table
      vrtclTblFiles: [],
      startingCol: 0,
      endingCol: 0,
      minColNo: Number.NEGATIVE_INFINITY,
      maxColNo: Number.POSITIVE_INFINITY,
      rowsVerticalTable: [],
      colIndexesRowVerticalTable: [],
      MAX_NUM_COLS_TO_FETCH_LAZILY_ON_SCROLL: 50,
      scrollPrevLeft: 0,

      MAX_WINDOW_SIZE: 100,
      thresholdPixels: 5,
      loading: false,
      loadingText: "",
      loadedUp: false,
      loadedLeft: false,
      errorOpen: false,
      errorInfo: {},
    };
    console.log("props to sheet", this.props);
  }

  componentDidMount() {
    this.setState({
      loading: true,
      loadingText: "Loading selected record...",
    });
    this.props.setLoadingState(true);
    this.intializeTable();
  }

  componentDidUpdate(prevProps) {
    // if (this.state.loadedUp) {
    //   console.log("loaded up!");
    //   this.scrollRef.current.scrollTop = 500;
    //   this.setState({
    //     loadedUp: false,
    //   });
    // }

    if (this.props.orientation === "horizontal" && this.props.headerRow == 1)
      this.handleUpdatedActiveRowNo(prevProps);
    if (this.props.orientation === "vertical" && this.props.headerColumn == "A")
      this.handleUpdatedActiveColNo(prevProps);
  }

  intializeTable = () => {
    const { orientation, headerColumn, headerRow } = this.props;
    if (orientation === "horizontal") {
      if (headerRow == 1) {
        this.initalizeHorizontalTable();
      } else {
        this.initalizeHorizontalMiscTable();
      }
    } else if (orientation === "vertical") {
      if (headerColumn == "A") {
        this.initalizeVerticalTable();
      } else {
        this.initalizeVerticalMiscTable();
      }
    }
    //  else if (orientation === "vertical_reverse") {
    //   this.initalizeVerticalReverseTable();
    // }
  };

  getDataForGivenRowRange = async (
    files,
    rqstdStartRow,
    rqstdEndRow,
    includeHeaders,
    headerRow,
    fileType,
    url
  ) => {
    // api call for initial set of data with header_required included
    try {
      console.log(
        "gdfgrr",
        files,
        rqstdStartRow,
        rqstdEndRow,
        includeHeaders,
        headerRow,
        fileType,
        url
      );
      let filesToBeFetched = [];

      let tempStartRow = rqstdStartRow;
      let tempEndRow = rqstdEndRow;

      for (let i = 0; i < files.length; i++) {
        let file = files[i];
        let { start_row, end_row, file_link } = file;

        if (tempStartRow < start_row) {
          break;
        } else {
          if (tempStartRow > end_row) {
            continue;
          } else {
            if (tempEndRow <= end_row) {
              filesToBeFetched.push({
                strtRow: tempStartRow,
                endRow: tempEndRow,
                fileLink: file_link,
              });
              break;
            } else {
              filesToBeFetched.push({
                strtRow: tempStartRow,
                endRow: end_row,
                fileLink: file_link,
              });
              tempStartRow = end_row + 1;
            }
          }
        }
      }

      console.log("files to be fetched", filesToBeFetched);
      let data = [];

      data = await Promise.all(
        filesToBeFetched.map(async (file, index) => {
          let include_headers
          if (this.props.shouldIncludeHeaders) {
            include_headers = includeHeaders && index === 0
          } else {
            include_headers = false
          }

          let res = await Actions("http_request", {
            url: url,
            method: "get",
            params: {
              file_link: file.fileLink,
              start_row: file.strtRow,
              end_row: file.endRow,
              include_headers : include_headers,
              //include_headers: includeHeaders && index === 0,
              header_row: headerRow,
              file_type: fileType,
            },
          });

          return res.data.data;
        })
      );

      data = data.flat();
      return data;
    } catch (err) {
      console.log("error while fetching");
      return [];
    }
  };

  //initialization of table when orientation is "horizontal" and header row is 1
  initalizeHorizontalTable = async () => {
    try {
      console.log("handle initialize horz table");

      let {
        activeRowNo,
        workSheets,
        selectedWorkSheetName,
        drlUrl,
        fileType,
        headerRow,
      } = this.props;

      //for arthimetic reasons convert and make sure it is a number.
      activeRowNo = Number(activeRowNo);
      if (isNaN(activeRowNo)) {
        throw new Error("invalid active row number format.");
      }
      console.log("initializing horzinatal", this.props, this.state);
      //get sleected worksheet
      let selectedWorkSheet = workSheets.filter(
        (workSheet) => workSheet.name === selectedWorkSheetName
      );
      //take first sheet matching the name
      selectedWorkSheet = selectedWorkSheet[0];
      const { max_row, max_column, files } = selectedWorkSheet;

      //assume as 2, 1 being header row
      let minRowNo = 1;
      let maxRowNo = max_row;
      // maxRowNo = max_row
      // console.log("Active Row Number : ", activeRowNo)
      if (activeRowNo < minRowNo || activeRowNo > maxRowNo) {
        throw new Error("invalid active row no");
      }
      const { MAX_WINDOW_SIZE } = this.state;

      let strtRow = Math.max(
        minRowNo,
        activeRowNo - Math.floor(MAX_WINDOW_SIZE / 2)
      );

      let endRow = Math.min(
        activeRowNo + Math.floor(MAX_WINDOW_SIZE / 2),
        maxRowNo
      );

      let data = await this.getDataForGivenRowRange(
        files,
        strtRow,
        endRow,
        true,
        headerRow,
        fileType,
        `${drlUrl}/drl/get_table_row_range`
      );

      //add sequence numbering to each row
      data = addRowSequenceNos(data,headerRow);
      // //add col_index values as excel don't have them.
      // data.forEach((dataRow) => {
      //   updateColIndex(dataRow);
      // });
      //first row is column header row.
      let columnNamesRow = data[0];
      // data.shift();

      //for excel we assume column names row is the largest row.
      let totalCols = columnNamesRow.length;
      let columnIndexesRow = getColumnIndexArray(totalCols, 0);
      //initialize state variables necessary for initial render.
      this.props.setLoadingState(false);
      this.setState(
        {
          startingRow: strtRow,
          endingRow: endRow,
          rows: data,
          loadingText: "",
          loading: false,
          minRowNo: minRowNo,
          maxRowNo: maxRowNo,
          columnIndexesRow: columnIndexesRow,
          columnNamesRow: columnNamesRow,
          hrzntlTblFiles: files,
        },
        () => {
          console.log("Initialized Horizontal Row : ", this.state)
          this.addResizing();
        }
      );
    } catch (err) {
      this.props.setLoadingState(false);
      this.setState({
        errorInfo: err,
        errorOpen: true,
        loadingText: "",
        loading: false,
      });
      console.log("error during mounting of sheet", err);
    }
  };
  //initialization of table when orientation is "horizontal" and header row is not "1"
  initalizeHorizontalMiscTable = async () => {
    try {
      console.log("handle initialize horz table");

      let {
        activeRowNo,
        workSheets,
        selectedWorkSheetName,
        drlUrl,
        fileType,
        headerRow,
      } = this.props;

      //for arthimetic reasons convert and make sure it is a number.
      activeRowNo = Number(activeRowNo);
      if (isNaN(activeRowNo)) {
        throw new Error("invalid active row number format.");
      }
      console.log("initializing horzinatal", this.props, this.state);
      //get sleected worksheet
      let selectedWorkSheet = workSheets.filter(
        (workSheet) => workSheet.name === selectedWorkSheetName
      );
      //take first sheet matching the name
      selectedWorkSheet = selectedWorkSheet[0];
      const { max_row, max_column, files } = selectedWorkSheet;

      //min row no is 1 for misc table.
      let minRowNo = 1;
      let maxRowNo = max_row;

      if (activeRowNo < minRowNo || activeRowNo > maxRowNo) {
        throw new Error("invalid active row no");
      }

      let data = await this.getDataForGivenRowRange(
        files,
        minRowNo,
        maxRowNo,
        true,
        headerRow,
        fileType,
        `${drlUrl}/drl/get_table_row_range`
      );
      //add sequence numbering to each row
      console.log("Table :::: Data Fetched : ", data)
      data = addRowSequenceNos(data, headerRow);
      console.log("Table :::: Row Sequence Added : ", data)

      let columnIndexesRow = getColumnIndexArray(max_column, 0);
      //initialize state variables necessary for initial render.
      this.props.setLoadingState(false);
      this.setState(
        {
          startingRow: minRowNo,
          endingRow: maxRowNo,
          rows: data,
          loadingText: "",
          loading: false,
          minRowNo: minRowNo,
          maxRowNo: maxRowNo,
          columnIndexesRow: columnIndexesRow,
          columnNamesRow: [],
          hrzntlTblFiles: files,
        },
        () => {
          console.log("Initialized Horizontal Misc Row : ", this.state)
          this.addResizing();
        }
      );
    } catch (err) {
      this.props.setLoadingState(false);
      this.setState({
        errorInfo: err,
        errorOpen: true,
        loadingText: "",
        loading: false,
      });
      console.log("error during mounting of sheet", err);
    }
  };
  //handle  updated active row no
  handleUpdatedActiveRowNo = async (prevProps) => {
    try {
      console.log("handle update active rowno");

      if (
        prevProps.activeRowNo !== this.props.activeRowNo &&
        this.props.activeRowNo !== null &&
        this.props.activeRowNo != 1
      ) {
        let { activeRowNo, drlUrl, fileType, headerRow } = this.props;
        //for arthimetic reasons convert and make sure it is a number.
        activeRowNo = Number(activeRowNo);
        if (isNaN(activeRowNo)) {
          throw new Error("invalid active row number format.");
        }
        //check if the active row no is in range
        if (
          activeRowNo < this.state.startingRow ||
          activeRowNo > this.state.endingRow
        ) {
          this.setState({
            loading: true,
            loadingText: "Loading selected record...",
          });
          this.props.setLoadingState(true);
          //assume as 2, 1 being header row
          let minRowNo = this.state.minRowNo;
          let maxRowNo = this.state.maxRowNo;
          // maxRowNo = max_row

          const { MAX_WINDOW_SIZE } = this.state;

          let strtRow = Math.max(
            minRowNo,
            activeRowNo - Math.floor(MAX_WINDOW_SIZE / 2)
          );

          let endRow = Math.min(
            activeRowNo + Math.floor(MAX_WINDOW_SIZE / 2),
            maxRowNo
          );

          let data = await this.getDataForGivenRowRange(
            this.state.hrzntlTblFiles,
            strtRow,
            endRow,
            false,
            headerRow,
            fileType,
            `${drlUrl}/drl/get_table_row_range`
          );

          data = addRowSequenceNos(data);
          this.props.setLoadingState(true);
          this.setState({
            loading: false,
            loadingText: "",
            rows: data,
            startingRow: strtRow,
            endingRow: endRow,
          });
        }
      }
    } catch (err) {
      console.log("dkljfalksjskd ", err);
      this.props.setLoadingState(false);
      this.setState({
        errorInfo: err,
        errorOpen: true,
        loadingText: "",
        loading: false,
      });
      console.log("error during updating sheet with new active row no", err);
    }
  };
  //initialization of table when orientation is "vertical" and header column is "A"
  initalizeVerticalTable = async () => {
    try {
      console.log("handle initialize vertical table");
      let {
        activeColNo,
        fileLink,
        workSheets,
        selectedWorkSheetName,
        drlUrl,
        headerColumn,
        fileType,
      } = this.props;

      //convert activ colno to no version
      activeColNo = colIndxStringToColNo(activeColNo);
      if (isNaN(activeColNo)) {
        throw new Error("invalid active column number format.");
      }
      //get sleected worksheet
      let selectedWorkSheet = workSheets.filter(
        (workSheet) => workSheet.name === selectedWorkSheetName
      );
      //take first sheet matching the name
      selectedWorkSheet = selectedWorkSheet[0];
      const { max_row, max_column, files } = selectedWorkSheet;

      //assume as 2, 1 being header row
      let minColNo = 2;
      let maxColNo = max_column;
      // maxRowNo = max_row

      if (activeColNo < minColNo || activeColNo > maxColNo) {
        throw new Error("invalid active column no");
      }
      const { MAX_WINDOW_SIZE } = this.state;

      let strtCol = Math.max(
        minColNo,
        activeColNo - Math.floor(MAX_WINDOW_SIZE / 2)
      );

      let endCol = Math.min(
        activeColNo + Math.floor(MAX_WINDOW_SIZE / 2),
        maxColNo
      );

      // api call for initial set of data with header_required included
      let res = await Actions("http_request", {
        url: `${drlUrl}/drl/get_table_column_range`,
        method: "get",
        params: {
          file_link: files[0].file_link,
          start_col: colNoToColIndxString(strtCol),
          end_col: colNoToColIndxString(endCol),
          include_headers: true,
          header_col: headerColumn,
          file_type: fileType,
        },
      });

      let data = res.data.data;

      //add sequence numbering to each row
      data = addRowSequenceNos(data);
      // //add col_index values as excel don't have them.
      // data.forEach((dataRow) => {
      //   updateColIndex(dataRow);
      // });

      //colindexes row shall contain header index("A") and
      // current column range indexes
      let colIndexesRowVerticalTable = getColumnIndexArrayForVerticalTable(
        headerColumn,
        strtCol,
        endCol
      );
      //header column is usually "A"

      //initialize state variables necessary for initial render.
      this.props.setLoadingState(false);
      this.setState(
        {
          startingCol: strtCol,
          endingCol: endCol,
          colIndexesRowVerticalTable: colIndexesRowVerticalTable,
          rowsVerticalTable: data,
          loadingText: "",
          loading: false,
          minColNo: minColNo,
          maxColNo: maxColNo,
          vrtclTblFiles: files,
        },
        () => {
          this.addResizing();
        }
      );
    } catch (err) {
      this.props.setLoadingState(false);
      this.setState({
        errorInfo: err,
        errorOpen: true,
        loadingText: "",
        loading: false,
      });
      console.log("error during mounting of sheet", err);
    }
  };

  //initialization of table when orientation is "vertical" and header column is not "A"
  initalizeVerticalMiscTable = async () => {
    try {
      console.log("handle initialize vertical table");
      let {
        activeColNo,
        workSheets,
        selectedWorkSheetName,
        drlUrl,
        headerColumn,
        fileType,
      } = this.props;

      //convert activ colno to no version
      activeColNo = colIndxStringToColNo(activeColNo);
      if (isNaN(activeColNo)) {
        throw new Error("invalid active column number format.");
      }
      //get sleected worksheet
      let selectedWorkSheet = workSheets.filter(
        (workSheet) => workSheet.name === selectedWorkSheetName
      );
      //take first sheet matching the name
      selectedWorkSheet = selectedWorkSheet[0];
      const { max_row, max_column, files } = selectedWorkSheet;

      //assume as 2, 1 being header row
      let minColNo = 1;
      let maxColNo = max_column;
      // maxRowNo = max_row

      if (activeColNo < minColNo || activeColNo > maxColNo) {
        throw new Error("invalid active column no");
      }

      // api call for initial set of data with header_required included
      let res = await Actions("http_request", {
        url: `${drlUrl}/drl/get_table_column_range`,
        method: "get",
        params: {
          file_link: files[0].file_link,
          start_col: colNoToColIndxString(minColNo),
          end_col: colNoToColIndxString(maxColNo),
          include_headers: false,
          header_col: headerColumn,
          file_type: fileType,
        },
      });

      let data = res.data.data;

      //add sequence numbering to each row
      data = addRowSequenceNos(data);
      // //add col_index values as excel don't have them.
      // data.forEach((dataRow) => {
      //   updateColIndex(dataRow);
      // });

      //colindexes row shall contain header index("A") and
      // current column range indexes
      let colIndexesRowVerticalTable = getColumnIndexArray(max_column);
      //header column is usually "A"

      //initialize state variables necessary for initial render.
      this.props.setLoadingState(false);
      this.setState(
        {
          startingCol: minColNo,
          endingCol: maxColNo,
          colIndexesRowVerticalTable: colIndexesRowVerticalTable,
          rowsVerticalTable: data,
          loadingText: "",
          loading: false,
          minColNo: minColNo,
          maxColNo: maxColNo,
          vrtclTblFiles: files,
        },
        () => {
          this.addResizing();
        }
      );
    } catch (err) {
      this.props.setLoadingState(false);
      this.setState({
        errorInfo: err,
        errorOpen: true,
        loadingText: "",
        loading: false,
      });
      console.log("error during mounting of sheet", err);
    }
  };
  //handle updated col no
  handleUpdatedActiveColNo = async (prevProps) => {
    try {
      if (
        prevProps.activeColNo !== this.props.activeColNo &&
        this.props.activeColNo !== null &&
        this.props.activeColNo != "A"
      ) {
        console.log("handle update active colno");

        let {
          activeColNo,
          fileLink,
          workSheets,
          selectedWorkSheetName,
          drlUrl,
          headerColumn,
          fileType,
        } = this.props;

        //convert activ colno to no version
        activeColNo = colIndxStringToColNo(activeColNo);
        if (isNaN(activeColNo)) {
          throw new Error("invalid active column number format.");
        }
        //get sleected worksheet
        let selectedWorkSheet = workSheets.filter(
          (workSheet) => workSheet.name === selectedWorkSheetName
        );
        //take first sheet matching the name
        selectedWorkSheet = selectedWorkSheet[0];
        const { max_row, max_column } = selectedWorkSheet;

        //assume as 2, 1 being header row
        let minColNo = 2;
        let maxColNo = max_column;
        // maxRowNo = max_row

        if (activeColNo < minColNo || activeColNo > maxColNo) {
          throw new Error("invalid active column no");
        }
        const { MAX_WINDOW_SIZE, vrtclTblFiles } = this.state;

        let strtCol = Math.max(
          minColNo,
          activeColNo - Math.floor(MAX_WINDOW_SIZE / 2)
        );

        let endCol = Math.min(
          activeColNo + Math.floor(MAX_WINDOW_SIZE / 2),
          maxColNo
        );

        // api call for initial set of data with header_required included
        let res = await Actions("http_request", {
          url: `${drlUrl}/drl/get_table_column_range`,
          method: "get",
          params: {
            file_link: vrtclTblFiles[0].file_link,
            start_col: colNoToColIndxString(strtCol),
            end_col: colNoToColIndxString(endCol),
            include_headers: true,
            header_col: headerColumn,
            file_type: fileType,
          },
        });

        let data = res.data.data;

        //add sequence numbering to each row
        data = addRowSequenceNos(data);
        // //add col_index values as excel don't have them.
        // data.forEach((dataRow) => {
        //   updateColIndex(dataRow);
        // });

        //colindexes row shall contain header index("A") and
        // current column range indexes
        let colIndexesRowVerticalTable = getColumnIndexArrayForVerticalTable(
          headerColumn,
          strtCol,
          endCol
        );
        //header column is usually "A"

        //initialize state variables necessary for initial render.
        this.props.setLoadingState(false);
        this.setState(
          {
            startingCol: strtCol,
            endingCol: endCol,
            colIndexesRowVerticalTable: colIndexesRowVerticalTable,
            rowsVerticalTable: data,
            loadingText: "",
            loading: false,
            minColNo: minColNo,
            maxColNo: maxColNo,
          },
          () => {
            this.addResizing();
          }
        );
      }
    } catch (err) {
      this.props.setLoadingState(false);
      this.setState({
        errorInfo: err,
        errorOpen: true,
        loadingText: "",
        loading: false,
      });
      console.log("error during mounting of sheet", err);
    }
  };
  //initialization of table when orientation is "vertical_reverse"
  initalizeVerticalReverseTable = async () => {};
  addResizing = () => {
    let pageHeight = this.scrollRef.current.scrollHeight;
    let scrollInitialY = Math.floor(pageHeight / 2) - 150;
    this.setState({ scrollPrevY: scrollInitialY });

    //handle expandable columns. closure is needed**
    var table = document.getElementById("excel-table");
    resizableGrid(table);
    function resizableGrid(table) {
      var row = table.getElementsByTagName("tr")[0];
      let cols = row ? row.children : undefined;
      if (!cols) return;
      for (var i = 0; i < cols.length; i++) {
        var div = createDiv(table.offsetHeight);
        cols[i].appendChild(div);
        // cols[i].style.position = "relative";
        setListeners(div);
      }
    }
    function createDiv(height) {
      var div = document.createElement("div");
      div.style.top = 0;
      div.style.right = "-2px";
      div.style.width = "4px";
      div.style.position = "absolute";
      div.style.cursor = "col-resize";
      /* remove backGroundColor later */
      // div.style.backgroundColor = "inherit";
      div.style.opacity = 0;
      div.style.userSelect = "none";
      /* table height */
      div.style.height = height + "px";
      return div;
    }

    function setListeners(div) {
      var pageX, curCol, nxtCol, curColWidth, nxtColWidth;
      div.addEventListener("mousedown", function (e) {
        curCol = e.target.parentElement;
        nxtCol = curCol.nextElementSibling;
        pageX = e.pageX;
        curColWidth = curCol.offsetWidth;
        if (nxtCol) nxtColWidth = nxtCol.offsetWidth;
      });

      document.addEventListener("mousemove", function (e) {
        if (curCol) {
          var diffX = e.pageX - pageX;

          if (nxtCol) nxtCol.style.minWidth = nxtColWidth - diffX + "px";

          curCol.style.minWidth = curColWidth + diffX + "px";
        }
      });

      document.addEventListener("mouseup", function (e) {
        curCol = undefined;
        nxtCol = undefined;
        pageX = undefined;
        nxtColWidth = undefined;
        curColWidth = undefined;
      });
    }
  };
  //todo:add resizing horizontally.
  handleScroll = (
    scrollCrntY,
    pageHeight,
    clientHeight,
    scrollLeft,
    pageWidth,
    clientWidth
  ) => {
    console.log("handle scroll");

    if (this.props.orientation === "horizontal") {
      this.handleVrtclScroll(scrollCrntY, pageHeight, clientHeight);
    } else if (this.props.orientation === "vertical") {
      this.handleHrzntlScroll(scrollLeft, pageWidth, clientWidth);
    } else if (this.props.orientation === "vertical_reverse") {
    }
  };
  //handle vertical scroll when table direction is "horizontal", load additional rows on scroll
  handleVrtclScroll = async (scrollCrntY, pageHeight, clientHeight) => {
    try {
      if (this.props.orientation === "horizontal") {
        console.log("handle vertical scroll");

        // return;
        let scrollOffset = scrollCrntY - this.state.scrollPrevY;

        this.setState({ scrollPrevY: scrollCrntY });
        const {
          activeRowNo,
          fileLink,
          workSheets,
          selectedWorkSheetName,
          drlUrl,
          fileType,
          headerRow,
        } = this.props;

        const {
          minRowNo,
          maxRowNo,
          startingRow,
          endingRow,
          MAX_WINDOW_SIZE,
          rows,
          hrzntlTblFiles,
          MAX_NUM_ROWS_TO_FETCH_LAZILY_ON_SCROLL,
          thresholdPixels,
        } = this.state;
        //fetch above records
        if (scrollOffset < 0) {
          if (startingRow <= minRowNo) return;
          if (scrollCrntY <= thresholdPixels) {
            this.props.setLoadingState(true);
            this.setState({
              loading: true,
              loadingText: "Loading above records...",
            });
            //verify boundary
            let strtRow =
              startingRow - Math.floor(MAX_NUM_ROWS_TO_FETCH_LAZILY_ON_SCROLL);
            if (strtRow < minRowNo) {
              strtRow = minRowNo;
            }

            let endRow = startingRow - 1;
            if (endRow < minRowNo) {
              endRow = minRowNo;
            }

            let data = await this.getDataForGivenRowRange(
              hrzntlTblFiles,
              strtRow,
              endRow,
              true,
              headerRow,
              fileType,
              `${drlUrl}/drl/get_table_row_range`
            );

            data = addRowSequenceNos(data, headerRow);
            //check for insufficient rows to display.if requested rows are less than threshold,
            // that is half the windowsize as per current design, we will fill those with existing rows in sequential order.
            let rowGap = MAX_WINDOW_SIZE - (endRow - strtRow + 1);
            if (rowGap > 0) {
              data = [...data, ...rows.slice(1, rowGap)];
            }
            this.props.setLoadingState(false);
            this.setState({
              loadedUp: true,
              loading: false,
              loadingText: "",
              rows: data,
              startingRow: strtRow,
              endingRow: endRow + rowGap,
            });
          }
        }
        //fetch below records
        else {
          if (endingRow >= maxRowNo) return;
          if (pageHeight - (clientHeight + scrollCrntY) <= thresholdPixels) {
            this.props.setLoadingState(true);
            this.setState({
              loading: true,
              loadingText: "Loading below records...",
            });
            let strtRow = endingRow + 1;
            if (strtRow > maxRowNo) {
              strtRow = maxRowNo;
            }
            let endRow =
              endingRow + Math.floor(MAX_NUM_ROWS_TO_FETCH_LAZILY_ON_SCROLL);
            if (endRow > maxRowNo) {
              endRow = maxRowNo;
            }

            let data = await this.getDataForGivenRowRange(
              hrzntlTblFiles,
              strtRow,
              endRow,
              true,
              headerRow,
              fileType,
              `${drlUrl}/drl/get_table_row_range`
            );

            data = addRowSequenceNos(data, headerRow);
            //check for insufficient rows to display.if requested rows are less than threshold,
            // that is half the windowsize as per current design, we will fill those with existing rows in sequential order.
            let rowGap = MAX_WINDOW_SIZE - (endRow - strtRow + 1);
            if (rowGap > 0) {
              data = [...rows.slice(-rowGap), ...data];
            }
            this.props.setLoadingState(false);

            this.setState({
              loading: false,
              loadingText: "",
              rows: data,
              startingRow: strtRow - rowGap,
              endingRow: endRow,
            });
          }
        }
      }
    } catch (err) {
      this.props.setLoadingState(false);
      this.setState({
        errorInfo: err,
        errorOpen: true,
        loading: false,
        loadingText: "",
      });
      console.log("error while handling scroll", err);
    }
  };
  //handle horizonatal scroll when table direction is "vertical" or "vertical_reverse",
  //load additional columns on scroll
  handleHrzntlScroll = async (scrollLeft, pageWidth, clientWidth) => {
    try {
      if (this.props.orientation === "vertical") {
        console.log("handle horiznotal scroll");

        // return;
        let scrollOffset = scrollLeft - this.state.scrollPrevLeft;

        this.setState({ scrollPrevLeft: scrollLeft });
        const {
          activeColNo,
          fileLink,
          workSheets,
          selectedWorkSheetName,
          drlUrl,
          headerColumn,
          fileType,
        } = this.props;

        const {
          minColNo,
          maxColNo,
          startingCol,
          endingCol,
          MAX_WINDOW_SIZE,
          rows,
          MAX_NUM_COLS_TO_FETCH_LAZILY_ON_SCROLL,
          thresholdPixels,
          vrtclTblFiles,
        } = this.state;
        //fetch more left side records
        if (scrollOffset < 0) {
          if (startingCol <= minColNo) return;
          if (scrollOffset <= thresholdPixels) {
            this.props.setLoadingState(true);
            this.setState({
              loading: true,
              loadingText: "Loading above records...",
            });
            //verify boundary
            let strtCol =
              startingCol - Math.floor(MAX_NUM_COLS_TO_FETCH_LAZILY_ON_SCROLL);
            if (strtCol < minColNo) {
              strtCol = minColNo;
            }

            let endCol = startingCol - 1;
            if (endCol < minColNo) {
              endCol = minColNo;
            }

            let res = await Actions("http_request", {
              url: `${drlUrl}/drl/get_table_column_range`,
              method: "get",
              params: {
                file_link: vrtclTblFiles[0].file_link,
                start_col: strtCol,
                end_col: endCol,
                include_headers: true,
                header_row: 1,
                file_type: fileType,
              },
            });

            let data = res.data.data;
            data = addRowSequenceNos(data);
            let colIndexArray = getColumnIndexArrayForVerticalTable(
              headerColumn,
              strtCol,
              endCol
            );
            // //check for insufficient rows to display.if requested rows are less than threshold,
            // // that is half the windowsize as per current design, we will fill those with existing rows in sequential order.
            // let colGap = MAX_WINDOW_SIZE - (endCol - strtCol + 1);
            // if (colGap > 0) {
            //   data = [...data, ...rows.slice(0, rowGap)];
            // }
            this.props.setLoadingState(false);
            this.setState({
              loadedLeft: true,
              loading: false,
              loadingText: "",
              colIndexesRowVerticalTable: colIndexArray,
              rowsVerticalTable: data,
              startingCol: strtCol,
              // endingCol: endCol + rowGap,
              endingCol: endCol,
            });
          }
        }
        //fetch more right side records
        else {
          if (endingCol >= maxColNo) return;
          if (pageWidth - (clientWidth + scrollLeft) <= thresholdPixels) {
            this.props.setLoadingState(true);
            this.setState({
              loading: true,
              loadingText: "Loading below records...",
            });
            let strtCol = endingCol + 1;
            if (strtCol > maxColNo) {
              strtCol = maxColNo;
            }
            let endCol =
              endingCol + Math.floor(MAX_NUM_COLS_TO_FETCH_LAZILY_ON_SCROLL);
            if (endCol > maxColNo) {
              endCol = maxColNo;
            }
            let res = await Actions("http_request", {
              url: `${drlUrl}/drl/get_table_column_range`,
              method: "get",
              params: {
                file_link: vrtclTblFiles[0].file_link,
                start_col: strtCol,
                end_col: endCol,
                include_headers: false,
                header_col: headerColumn,
                file_type: fileType,
              },
            });

            let data = res.data.data;
            data = addRowSequenceNos(data);
            let colIndexArray = getColumnIndexArrayForVerticalTable(
              headerColumn,
              strtCol,
              endCol
            );
            // //check for insufficient rows to display.if requested rows are less than threshold,
            // // that is half the windowsize as per current design, we will fill those with existing rows in sequential order.
            // let rowGap = MAX_WINDOW_SIZE - (endRow - strtRow + 1);
            // if (rowGap > 0) {
            //   data = [...rows.slice(-rowGap), ...data];
            // }
            this.props.setLoadingState(false);

            this.setState({
              loading: false,
              loadingText: "",
              colIndexesRowVerticalTable: colIndexArray,
              rowsVerticalTable: data,
              // startingRow: strtRow - rowGap,
              startingCol: strtCol,
              endingCol: endCol,
            });
          }
        }
      }
    } catch (err) {
      this.props.setLoadingState(false);
      this.setState({
        errorInfo: err,
        errorOpen: true,
        loading: false,
        loadingText: "",
      });
      console.log("error while handling scroll", err);
    }
  };
  debounce = (handler, time) => {
    let timer;

    return function (event) {
      /*******metrics used for vertical scroll****** */
      //scrolltop: amount content scrolled abve container boundary.
      let scrollTop = event.target.scrollTop;
      //pageheight: total content height
      let pageHeight = event.target.scrollHeight;
      //clientHeight: container height
      let clientHeight = event.target.clientHeight;

      /*******metrics used for horizontal scroll****** */
      //scrolltop: amount content scrolled abve container boundary.
      let scrollLeft = event.target.scrollLeft;
      //pageWidth: total content width
      let pageWidth = event.target.scrollWidth;
      //clientWidth: container width
      let clientWidth = event.target.clientWidth;
      if (timer) {
        clearTimeout(timer);
      }
      timer = setTimeout(() => {
        handler(
          scrollTop,
          pageHeight,
          clientHeight,
          scrollLeft,
          pageWidth,
          clientWidth
        );
      }, time);
    };
  };

  handleErrorClose = () => {
    this.setState({
      errorOpen: false,
    });
  };

  renderLoader = () => {
    console.log("rendering loader", this.state.loading === true);
    if (this.state.loading === true) {
      //get height of
      let cellFormulaCont = document.getElementById(
        "cell-indices-formula-value-container"
      );
      let height = cellFormulaCont.style.height;
      return (
        <>
          <div
            classes="overlay-dialog"
            style={{
              width: "100%",
              height: "100%",
              position: "absolute",
              top: height,
              left: 0,
              backgroundColor: "#000",
              opacity: 0.5,
              zIndex: 10,
            }}
          ></div>
          <Typography
            style={{
              color: "white",
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: `translate(-50%, -50%)`,
              zIndex: 10,
              opacity: 1,
            }}
          >
            {this.state.loadingText}{" "}
          </Typography>
          <CircularProgress
            size={30}
            style={{
              position: "absolute",
              top: "54%",
              left: "50%",
              zIndex: 10,
              color: "white",
            }}
          />
        </>
      );
    } else return "";
  };
  renderRows = () => {
    const {
      activeCell,
      updateActiveCell,
      activeRowNo,
      updateActiveRowNo,
      activeColNo,
      updateActiveColNo,
      orientation,
      containerHeight,
      headerRow,
      headerColumn,
      classes,
    } = this.props;
    console.log("orientation", orientation);
    if (orientation === "horizontal") {
      console.log("handle render horizontal rows", this.state);
      // let rows = [this.state.columnIndexesRow]
      // if () {

      // }
      console.log("Row Data : ", this.state.rows)
      return [
        this.state.columnIndexesRow,
        // this.state.columnNamesRow,
        ...this.state.rows,
      ].map(function (rowData) {
        if (rowData.length <= 0) {
          return null;
        } else {
          return (
            <Row
              key={rowData[0].row_index}
              containerHeight={containerHeight}
              rowData={rowData}
              isActive={rowData[0].row_index == activeRowNo}
              updateActiveCell={updateActiveCell}
              orientation={orientation}
              activeRowNo={activeRowNo}
              activeColNo={activeColNo}
              activeCell={activeCell}
              headerRow={headerRow}
              headerColumn={headerColumn}
              updateActiveRowNo={updateActiveRowNo}
              updateActiveColNo={updateActiveColNo}
            ></Row>
          );
        }
      });
    } else if (orientation === "vertical") {
      console.log("handle render verical  rows");

      return [
        this.state.colIndexesRowVerticalTable,
        ...this.state.rowsVerticalTable,
      ].map(function (rowData) {
        if (rowData.length <= 0) {
          return null;
        } else {
          return (
            <Row
              key={rowData[0].row_index}
              containerHeight={containerHeight}
              rowData={rowData}
              isActive={rowData[0].row_index == activeRowNo}
              updateActiveCell={updateActiveCell}
              activeCell={activeCell}
              orientation={orientation}
              activeRowNo={activeRowNo}
              activeColNo={activeColNo}
              headerRow={headerRow}
              headerColumn={headerColumn}
              updateActiveRowNo={updateActiveRowNo}
              updateActiveColNo={updateActiveColNo}
            ></Row>
          );
        }
      });
    }
    //  else if (orientation === "vertical_reverse") {
    //   return <div>still not handled</div>;
    // }
    else {
      return <div>failed to load.</div>;
    }
  };
  render() {
    console.log("loading", this.state.loading);
    return (
      <table
        id="excel-table"
        style={{
          width: "100%",
          height: "100%",
          tableLayout: "fixed",
          display: "block",
          borderCollapse: "seperate",
          borderSpacing: 0,
          fontSize: "11pt",
          overflowY: "scroll",
          flex: 1,
        }}
        onScroll={this.debounce(this.handleScroll, 100)}
        ref={this.scrollRef}
        className="sheet"
      >
        {this.renderLoader()}
        {this.renderRows()}

        <ErrorMessageAlert
          open={this.state.errorOpen}
          handleClose={this.handleErrorClose}
          errorInfo={this.state.errorInfo}
        ></ErrorMessageAlert>
      </table>
    );
  }
}

export default withStyles(useStyles)(Sheet);
